import { Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth-guard';
import { RoleGuard } from 'app/guards/role-guard';

export const DataCheckerRoutes: Routes = [
  {
    path: 'dashboard',
    loadComponent: () =>
      import('@pages/data-checker/dashboard/dashboard').then(
        (m) => m.Dashboard,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      // expectedRole: 'Scripter',
    },
  },
  {
    path: 'dashboard/interview-details/:id',
    loadComponent: () =>
      import('@pages/data-checker/interviewer-details/interviewer-details').then(
        (m) => m.InterviewerDetails,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'Data Checker',
    },
  },
  {
    path: 'dashboard/interview-report/:projectId/:interviewerId',
    loadComponent: () =>
      import('@pages/data-checker/survey-report/survey-report').then(
        (m) => m.SurveyReport,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'Data Checker',
    },
  },
  {
    path: 'project-management',
    loadComponent: () =>
      import('@pages/data-checker/project-management/project-management').then(
        (m) => m.ProjectManagement,
      ),
    data: {
      isSidebar: 1,
      isHeader: 1,
      // expectedRole: 'Scripter',
    },
  },
  {
    path: 'data-sync',
    canActivate: [AuthGuard.canActivate, RoleGuard.canActivate],
    loadComponent: () =>
      import('@pages/supervisor/data-sync/data-sync').then((m) => m.DataSync),
    data: {
      isSidebar: 1,
      isHeader: 1,
      expectedRole: 'Data Checker',
    },
  },
];
